import { CategoriasWebMenu } from "./categorias-webmenu.interface";
import { TagsEcommerce } from "./tags-eccomerce.interface";

export interface ResultadosDeBusquedaInterface {
    totaldeArticulos: number,
    textodebusqueda: string,
    categoria?: CategoriasWebMenu
    tagsEnbusqueda?: Map<number, TagsEcommerce>
}